/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    arrayOf, func, number, object, shape, string,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import subscriptionConfig from '../../../../helpers/common/subscription/subscription-helpers';

const styles = () => ({
    dropdownLabel: {
        width: '100%',
        '& span': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '10px 0',
            cursor: 'pointer',
        },
    },
    listContainer: {
        width: '100%',
        '& div': {
            borderTop: '1px solid rgb(0,0,0, 0.3)',
            padding: '10px 0',
            '&:hover': {
                backgroundColor: 'rgb(0,0,0, 0.05)',
                cursor: 'pointer',
            },
        },
    },
});

const DurationDropDown = ({
    classes,
    subscription,
    subscriptionsList,
    durationText,
    setDurationValue,
    updateSubscriptionList,
}) => {
    const [openDurationList, setOpenDurationList] = useState(false);

    const handleDurationDropDown = () => {
        setOpenDurationList(!openDurationList);
    };

    const durationDropdownList = Object.keys(subscriptionConfig?.['subscription_duration']).map((item) => {
        const obj = {
            id: Number(item),
            value: subscriptionConfig?.['subscription_duration'][item],
        };
        return obj;
    });

    const durationOptionList = durationDropdownList.filter((item) => subscriptionsList?.['duration']?.includes?.(item.id));

    const handleDurationChange = (duration) => {
        setDurationValue(duration.id);
        updateSubscriptionList({ ...subscription, duration: duration.id });
        handleDurationDropDown();
    };

    return (
        <div>
            <div
                aria-hidden="true"
                onClick={handleDurationDropDown}
                className={classes.dropdownLabel}
            >
                <span>{durationText} {openDurationList ? <ExpandLessIcon /> : <ExpandMoreIcon />}</span>
            </div>
            <div className={classes.listContainer}>
                {openDurationList && durationOptionList.map((item) => (
                    <div
                        key={item.id}
                        aria-hidden="true"
                        onClick={() => handleDurationChange(item)}
                    >
                        {item?.value}
                    </div>
                ))}
            </div>
        </div>
    );
};

DurationDropDown.propTypes = {
    classes: object.isRequired,
    subscription: object.isRequired,
    subscriptionsList: shape({
        duration: arrayOf(
            number,
        ),
        type: arrayOf(
            string,
        ),
        interval: arrayOf(
            number,
        ),
    }).isRequired,
    durationText: string.isRequired,
    setDurationValue: func,
    updateSubscriptionList: func,
};

DurationDropDown.defaultProps = {
    updateSubscriptionList: () => {},
    setDurationValue: () => {},
};

export default withStyles(styles)(DurationDropDown);
